/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Cmspostcategory_Delete_Aria2Inputs */

const vi_cmspostcategory_delete_aria2 = /** @type {(inputs: Cmspostcategory_Delete_Aria2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xoá chuyên mục ${i?.label}`)
};

/**

* @param {Cmspostcategory_Delete_Aria2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspostcategory_delete_aria2 = /** @type {((inputs: Cmspostcategory_Delete_Aria2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspostcategory_Delete_Aria2Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspostcategory_delete_aria2(inputs)
});
export { cmspostcategory_delete_aria2 as "cmsPostCategory_delete_aria" }